<template>
    <div class="d-flex align-items-center">
        <span v-if="value.status === 1"><b-icon icon="circle-fill" variant="warning" class="mr-2"/></span>
        <span v-if="value.status === 2"><b-icon icon="circle-fill" variant="success" class="mr-2"/></span>
        <span v-if="value.status === 3"><b-icon icon="circle-fill" variant="danger" class="mr-2"/></span>
        <span>{{ value.label }}</span>
    </div>
</template>

<script>
    export default {
        name: "RaidStatusCell",
        props: {
            value: { }
        }
    }
</script>

<style scoped>

</style>